import { gql } from "gql";

export const SAVE_NOTIFICATION_TEMPLATE = gql(/* GraphQL */ `
  mutation SaveNotificationTemplateValue(
    $template: NotificationTemplateValueInput
  ) {
    saveNotificationTemplateValue(template: $template)
  }
`);
